const intRegex = /^\d*$/;
const numberRegex = /^-?\d*\.?\d*$/;
const textRegex = /^[a-zA-Z ]+$/;
const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function mustBeFilled(input, label = 'Input') {
  return input !== null && input !== '' ? '' : `${label} harus diisi`;
}

export function mustBeInteger(input, label = 'Input') {
  return intRegex.test((input || '').toString()) ? '' : `${label} harus berupa bilangan bulat positif`;
}

export function mustBeFilledInteger(input, label = 'Input') {
  return mustBeFilled(input, label) || mustBeInteger(input, label);
}

export function mustBeNumber(input, label = 'Input') {
  return numberRegex.test((input || '').toString()) ? '' : `${label} harus berupa angka`;
}

export function mustBeFilledNumber(input, label = 'Input') {
  return mustBeFilled(input, label) || mustBeNumber(input, label);
}

export function mustBeGreaterThan(inputA, inputB, label = '') {
  if (inputB === null) return '';
  return inputA < inputB ? '' : `Harus lebih besar dari ${label || inputA}`;
}

export function mustBeText(input, label = 'Input') {
  return textRegex.test(input) ? '' : `${label} hanya boleh diisi huruf`;
}

export function mustBeFilledText(input, label = 'Input') {
  return mustBeFilled(input, label) || mustBeText(input, label);
}

export function mustBeEmail(input, label = 'Input') {
  return emailRegex.test(input) ? '' : `${label} harus sesuai format email`;
}
